import { IGetRecommendationsNearResponse } from 'shared/common/repositories/newbuilding-search/entities/get_recommendations_near_newbuilding/GetRecommendationsNearResponse';
import { TApplicationState } from 'shared/mf-infrastructure/types/redux';

export function selectSimilarNewbuildingsApiResult(state: TApplicationState): IGetRecommendationsNearResponse | null {
  return state.similarNewbuildings.data;
}
